// extracted by mini-css-extract-plugin
export default {"menuBlock":"JH-z","title":"KH-z","nav":"LH-z","flexCell":"MH-z","facetLink":"NH-z"};